import React, { Component } from 'react';
//import $ from 'jquery';
import api from '../../../services/api';
import { Modal } from 'react-bootstrap';
import querystring from 'querystring';
import loadingGif from '../../../img/loading-gif.gif';

export default class InformativoForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			titulo: '',
			conteudo: '',
			situacao: '',
			tag: '',
		};

		if (this.props.item) {
			const item = this.props.item;
			this.state = {
				id: item.id,
				titulo: item.titulo,
				conteudo: item.conteudo,
				situacao: item.situacao,
				tag: item.tag,
			};
		}

		this.handleChangeInput = this.handleChangeInput.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (this.props.item !== prevProps.item) {
			const item = this.props.item;

			this.setState({
				id: item.id,
				titulo: item.titulo,
				conteudo: item.conteudo,
				situacao: item.situacao,
				tag: item.tag,
			});
		}
	}

	cancelForm() {

		if(this.props.item){

		const item = this.props.item;

		this.setState({
			id: item.id,
			titulo: item.titulo,
			conteudo: item.conteudo,
			situacao: item.situacao,
			tag: item.tag,
		});}
		else{
			this.resetForm()
		}
	}

	resetForm() {
		this.setState({
			titulo: '',
			conteudo: '',
			situacao: '',
			tag: '',
		});
	}
	handleChangeInput(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value,
		});
	}

	async handleSubmit(e, setModalVisible) {
		e.preventDefault();

		var self = this;
		//var data = this.state;

		const qsData = querystring.stringify(this.state);

		this.setState({
			loading: true,
		});
		const options = {
			//method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			//data: x,
			//url: '/admin/unidade',
		};

		try {
			const response = await api.post('/admin/informativo', qsData,options);
			////console.log(response.data)
			if (response.status === 200 && response.data.id) {
				self.props.callback(response.data);
				setModalVisible(false);
				this.setState({
					loading: false,
				});
			} else {
				////console.log(response.status);
				////console.log(response.data);
			}
		} catch (error) {
			console.log(error);
			alert('Error' + error);
			
			this.setState({
				loading: false,
			});
			alert('Error: ' + error);
			if (error.response.status === 401) {
				window.location.reload();
			}
		}

		/*

        api.post('/admin/informativo', data)
        .then(function(data, status) {
            if (status == "success" && data.id) {
                self.props.callback();
                $('#' + self.props.elementId).modal('hide');
            }
        });

        */
	}

	render() {
		const informativo = this.state;
		const props = this.props;
		const { modalVisible, setModalVisible } = props;

		return (
			<Modal
				show={modalVisible}
				onHide={() => {
					setModalVisible(false);
				}}>
				<Modal.Header>
					<h2 className='modal-title'>
						{props.item ? 'Editar Informativo' : 'Novo Informativo'}
					</h2>
				</Modal.Header>
				<Modal.Body>
					<form
						id={props.elementId + 'Elem'}
						onSubmit={(e) => {
							this.handleSubmit(e, setModalVisible);
						}}>
						<div className='modal-body'>
							<div className='form-group'>
								<label>Título</label>
								<input
									className='form-control'
									type='text'
									name='titulo'
									value={informativo.titulo}
									onChange={this.handleChangeInput}
								/>
							</div>
							<div className='form-group'>
								<label>Situação</label>
								<select
									className='form-control'
									name='situacao'
									value={informativo.situacao}
									onChange={this.handleChangeInput}>
									<option value=''>Selecione</option>
									<option value='0'>Inativo</option>
									<option value='1'>Ativo</option>
								</select>
							</div>
							<div className='form-group'>
								<label>Tag</label>
								<input
									className='form-control'
									type='text'
									name='tag'
									value={informativo.tag}
									onChange={this.handleChangeInput}
								/>
							</div>
							<div className='form-group'>
								<label>Conteúdo</label>
								<textarea
									className='form-control'
									type='text'
									name='conteudo'
									value={informativo.conteudo}
									onChange={this.handleChangeInput}></textarea>
							</div>
						</div>
						<div className='modal-footer'>
							<button
								type='button'
								onClick={(e) => {
									e.preventDefault();
									//this.resetForm();
									this.cancelForm();

									setModalVisible(false);
								}}
								className='btn btn-light border'
								data-dismiss='modal'>
								Cancelar
							</button>
							<button type='submit' className='btn btn-primary'>
								{informativo.loading ? (
									<img className='loadingImg' src={loadingGif} alt='loading' />
								) : (
									'Salvar'
								)}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		);
	}
}
